import { Fragment } from 'react';
import useLeftNavigation from './UseLeftNavigation';

import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

import LeftNav from '@usas/ui-web/components/leftNav/LeftNav';
import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';

import { formatDate, formatDateTimeTwelveHourClock } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import style from '../../views/host/Host.module.css';

const LeftNavigation = ({ viewName, orgUnitAthleteEntryInfoState, omeMeetOrgUnitAthleteEntryIndividualRosterEntryState, children }) => {
  const { items, meetHost, meetName, meetClassification, meetDates, athleteEntryStatus, onNavigateToPath } = useLeftNavigation(viewName);
  const { leftNavModalState, onLeftNavModalCanceled } = useLeftNavModalData();
  if (Array.isArray(items) && items.length > 0) {
    return (
      <Fragment>
        <LeftNav formattedTitle={(
          <div className={style.RegFor}>
            <Headings.H5>Meet Host:</Headings.H5>
            <Headings.H6>{meetHost}</Headings.H6>
            <Headings.H5>Meet Name:</Headings.H5>
            <Headings.H6>{meetName}</Headings.H6>
            <Headings.H5>Meet Start - End Dates:</Headings.H5>
            <Headings.H6>{meetDates}</Headings.H6>
            <Headings.H5>Meet Classification:</Headings.H5>
            <Headings.H6>{meetClassification}</Headings.H6>
            <Headings.H5>Athlete Entry Status:</Headings.H5>
            <Headings.H6>{athleteEntryStatus}</Headings.H6>
          </div>
        )} state={items}
          validateBeforeRedirect={true}>
          <div className="row usas-extra-bottom-margin">
            <div className='col-xs-12'>
              <p className={global.HeaderText}><b>Athlete:</b>  {(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.firstName || omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.middleName || omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.lastName) ? `${omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.firstName || ''} ${omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.preferredName !== '' && omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.preferredName !== omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.firstName ? '"' + omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.preferredName + '"' : ''} ${omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.middleName || ''} ${omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.lastName || ''}` : ''} ({omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.competitionGenderTypeName || ''}, {omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.ageAtMeet >= 0 ? omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.ageAtMeet : ''})</p>
              <p className={global.HeaderText}><b>Athlete Birth Date:</b> {omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.birthDate ? formatDate(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.birthDate) : ''}</p>
              <p className={global.HeaderText}><b>Athlete Entry Status:</b> {omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData.status || ''}</p>
              <p className={global.HeaderText}><b>Team Name:</b> {`${orgUnitAthleteEntryInfoState.objData.teamOrgUnitName || ''} ${orgUnitAthleteEntryInfoState.objData.teamOrgUnitName === 'Unattached' ? orgUnitAthleteEntryInfoState.objData.teamParentOrgUnitName ? '- ' + orgUnitAthleteEntryInfoState.objData.teamParentOrgUnitName : '' : ''} ${orgUnitAthleteEntryInfoState.objData.teamParentOrgUnitCode ? '(' + orgUnitAthleteEntryInfoState.objData.teamParentOrgUnitCode + ')' : ''}`}</p>
              <p className={global.HeaderText}><b>OME Meet Name:</b> {orgUnitAthleteEntryInfoState.objData.omeMeetName || ''}</p>
              {orgUnitAthleteEntryInfoState.objData.orgUnitRegistrationStartDate &&
                <div>
                  <p className={global.HeaderText}><b>Athlete Entry Dates:</b>
                    &nbsp;{orgUnitAthleteEntryInfoState.objData.orgUnitRegistrationStartDate ? formatDateTimeTwelveHourClock(orgUnitAthleteEntryInfoState.objData.orgUnitRegistrationStartDate) : ''} - {orgUnitAthleteEntryInfoState.objData.orgUnitRegistrationEndDate ? formatDateTimeTwelveHourClock(orgUnitAthleteEntryInfoState.objData.orgUnitRegistrationEndDate) : ''}
                    &nbsp;{orgUnitAthleteEntryInfoState.objData.timeZone ? orgUnitAthleteEntryInfoState?.objData?.timeZone : ''}</p></div>}
              <p className={global.HeaderText}><b>Qualifying Date Range:</b>
                &nbsp;{orgUnitAthleteEntryInfoState?.objData?.hasTimeStandards === false ? 'N/A (Meet does not use Time Standards)' : orgUnitAthleteEntryInfoState?.objData?.hasQualifyingWindow === true ? `${formatDate(orgUnitAthleteEntryInfoState?.objData?.timeStandardsQualifyingStartDate)} - ${formatDate(orgUnitAthleteEntryInfoState?.objData?.timeStandardsQualifyingEndDate)}` : 'N/A (OME Meet does not use a Qualifying Window)'}</p>
              {orgUnitAthleteEntryInfoState?.objData?.meetPacketUrl && <p className={global.HeaderText}><b>Meet Packet:</b> <a href={orgUnitAthleteEntryInfoState?.objData?.meetPacketUrl} target="_blank" rel="noreferrer">Click Here to View</a></p>}
            </div>
          </div>
          {children}
        </LeftNav>
        <PopUpModal
          widthPct={90}
          maxWidth={720}
          title={leftNavModalState.modalTitle || 'The information on this page has not been saved'}
          displayPopUp={leftNavModalState.displayPopUp}
          onModalCanceled={onLeftNavModalCanceled}>
          <div className="row">
            <div className="col-xs-12">
              <p className={['text-center', global.Bold].join(' ')}>You are about to navigate away from this page without saving...</p>
              <p className='usas-extra-top-margin usas-extra-bottom-margin'></p>
              <p className='text-center'>Are you sure you want to continue? The information you entered has not been saved!</p>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 text-center usas-extra-top-margin">
              <SecondaryButton type="button" onClick={onLeftNavModalCanceled}>Cancel</SecondaryButton>&nbsp;&nbsp;
              <PrimaryButton type="button" onClick={(e) => onNavigateToPath(e, leftNavModalState.path)}>Continue</PrimaryButton>
            </div>
          </div>
        </PopUpModal>
      </Fragment>
    );
  } else {
    return (
      <LeftNav>
        {children}
      </LeftNav>
    );
  }
};

export default LeftNavigation;